// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMediaAudioMediumSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.331 19.741 8.59 16.138a.5.5 0 0 0-.347-.14H4.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3.743a.5.5 0 0 0 .347-.14l3.741-3.601C12.975 3.677 14 4.134 14 5v13.998c0 .866-1.025 1.322-1.669.743zM16 14.5v-5c0-.276.232-.504.486-.397C17.3 9.447 18 10.613 18 12c0 1.386-.7 2.553-1.514 2.897-.254.108-.486-.12-.486-.397z"
    />
  </svg>
);
export default SvgMediaAudioMediumSolid;
